<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre1">Foreword by Curt Thompson, MD</a></div>
<div class="SOM_pre"><a href="#/pre2">Introduction: The Power of Loving Connection</a></div>
<div class="SOM_part"><a href="#/p1">P<span class="small">ART</span> O<span class="small">NE</span>: T<span class="small">HE</span> C<span class="small">ONNECTION</span> C<span class="small">RISIS</span></a></div>
<div class="SOM_chap"><a href="#/p1chap1"><b>1</b> The Causes of Our Connection Crisis</a></div>
<div class="SOM_chap"><a href="#/p1chap2"><b>2</b> The Spiritual Effects of Our Connection Crisis</a></div>
<div class="SOM_chap"><span href="#/p1chap3" title="Link target outside of Sample"><b>3</b> Misguided Spirituality</span></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">P<span class="small">ART</span> T<span class="small">WO</span>: R<span class="small">ELATIONAL</span> K<span class="small">NOWLEDGE</span></span></div>
<div class="SOM_chap"><span href="#/p2chap1" title="Link target outside of Sample"><b>4</b> We Know More Than We Can Say</span></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample"><b>5</b> Once More with Feeling</span></div>
<div class="SOM_part"><span href="#/p3" title="Link target outside of Sample">P<span class="small">ART</span> T<span class="small">HREE</span>: A<span class="small">TTACHMENT</span> B<span class="small">ONDS</span></span></div>
<div class="SOM_chap"><span href="#/p3chap1" title="Link target outside of Sample"><b>6</b> Born to Connect</span></div>
<div class="SOM_chap"><span href="#/p3chap2" title="Link target outside of Sample"><b>7</b> Becoming Attached</span></div>
<div class="SOM_chap"><span href="#/p3chap3" title="Link target outside of Sample"><b>8</b> How We Connect to God and Others</span></div>
<div class="SOM_part"><span href="#/p4" title="Link target outside of Sample">P<span class="small">ART</span> F<span class="small">OUR</span>: T<span class="small">RANSFORMATION</span></span></div>
<div class="SOM_chap"><span href="#/p4chap1" title="Link target outside of Sample"><b>9</b> Born to Love</span></div>
<div class="SOM_chap"><span href="#/p4chap2" title="Link target outside of Sample"><b>10</b> Deep Love</span></div>
<div class="SOM_chap"><span href="#/p4chap3" title="Link target outside of Sample"><b>11</b> Understanding Deep Growth</span></div>
<div class="SOM_chap"><span href="#/p4chap4" title="Link target outside of Sample"><b>12</b> Cultivating Deep Growth</span></div>
<div class="SOM_chap"><span href="#/p4chap5" title="Link target outside of Sample"><b>13</b> Suffering Well</span></div>
<div class="SOM_chap"><span href="#/p4chap6" title="Link target outside of Sample"><b>14</b> Born to Belong</span></div>
<div class="SOM_appen"><span href="#/appen1" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen2" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Praise for <i>The Connected Life</i></span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?6ae38517